import apiClient from './apiClient';

export const getCampaigns = () => apiClient.get('/campaigns');
export const getAvailableCampaigns = () => apiClient.get('/campaigns/available');
export const getCampaignDetail = (id) => apiClient.get(`/campaigns/${id}`);
export const submitTweet = (campaignId, tweetUrl) =>
  apiClient.post(`/campaigns/${campaignId}/submit-tweet`, { tweetUrl });
export const submitCampaignInterest = (campaignId) =>
  apiClient.post(`/campaigns/${campaignId}/interest`);

export const getTakeoverCampaigns = () => apiClient.get('/takeover/campaigns');
export const getTakeoverDetail = (id) => apiClient.get(`/takeover/campaigns/${id}`);
export const getTakeoverLeaderboard = (id, page = 1) => apiClient.get(`/takeover/campaigns/${id}/leaderboard?page=${page}`);
export const submitTakeoverTweet = (id, tweetUrl) => apiClient.post(`/takeover/campaigns/${id}/submit`, { tweetUrl });
